export default __webpack_public_path__ + "static/media/icon-eye32@3x.b472e9c5.svg";